import { ChatApiEndpointWithId } from '@scale/shared/types/chat';
import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ModelEvalCardShared,
  type ModelEvalSchemaType,
  type ModelEvalContext,
  MODEL_EVAL,
} from '@scale/genai-compass-shared/cards/model_eval/card';
import ModelEvalCardComponent from './ModelEvalCardComponent';
import { faRobot } from '@fortawesome/pro-solid-svg-icons';

const DEFAULT_ENDPOINTS: ChatApiEndpointWithId[] = [
  {
    id: 'endpoint_LiteLLMStrategy_1',
    url: 'https://litellm.ml-serving-internal.scale.com/v1/chat/completions',
    params: {
      model: 'gpt-4o-mini',
      provider: 'openai',
    },
  },
];

const defaultContext: ModelEvalContext = {
  cardType: MODEL_EVAL,
  evalConfigs: [
    {
      modelConfigs: DEFAULT_ENDPOINTS,
      promptTemplate: '',
      outputColumn: 'output',
    },
  ],
  projectId: '',
  useCache: true,
};

export const ModelEvalCardInfo: CompassCardUI<ModelEvalSchemaType, ModelEvalContext> = {
  ...ModelEvalCardShared,
  title: 'Model Eval',
  inBeta: true,
  icon: 'robot',
  toolTip: 'Transform data with any model',
  defaultContext,
  ownerTeam: 'Connectivity',
  isDefault: true,
  legacyComponent: ModelEvalCardComponent,
  button: {
    icon: faRobot,
  },
};
